export const getAlsaceData = () => ({
  name: "Alsace",
  country: "France",
  description: "L'Alsace est une région viticole unique en France, produisant principalement des vins blancs aromatiques et des vins effervescents de qualité. Cette région du nord-est bénéficie d'un climat continental sec et de sols très variés qui donnent aux vins leur caractère distinctif.",
  type: "region",
  mapAreas: [
    { region: "Alsace", x: 50, y: 35, color: "#4B164C", size: 4 }
  ],
  statistics: {
    totalArea: "15,000 ha",
    production: "1.2 million hectolitres",
    appellations: "51 grands crus",
    villages: "119 communes",
    exportPercentage: "30%"
  },
  characteristics: {
    climate: "Climat continental sec avec des hivers froids et des étés chauds",
    soil: "Sols très variés : granit, calcaire, schiste, argile, sable",
    viticulture: "Viticulture traditionnelle, vendanges manuelles, vins de cépage"
  },
  wineStyles: {
    white: "Vins blancs secs et aromatiques, de la fraîcheur à la complexité",
    rose: "Rosés secs et fruités, parfaits pour l'apéritif",
    sparkling: "Crémant d'Alsace, vins effervescents de qualité",
    sweet: "Vendanges tardives et sélections de grains nobles"
  },
  history: "La viticulture en Alsace remonte à l'époque romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XIXe siècle a vu l'émergence des grands crus. Aujourd'hui, l'Alsace est reconnue pour ses vins blancs de qualité.",
  foodPairing: "Charcuteries, fromages, poissons, volailles, cuisine alsacienne traditionnelle",
  subregions: {
    "bas-rhin": {
      name: "Bas-Rhin",
      description: "Région septentrionale produisant des vins blancs secs et aromatiques, avec une forte identité terroir.",
      characteristics: {
        climate: "Climat continental sec",
        soil: "Sols de granit, calcaire et argile",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Riesling", "Gewürztraminer", "Pinot Gris", "Pinot Blanc"],
        red: ["Pinot Noir"]
      },
      wineStyles: {
        "riesling-bas-rhin": "Vins blancs secs et minéraux",
        "gewurztraminer-bas-rhin": "Vins blancs aromatiques et complexes",
        "pinot-gris-bas-rhin": "Vins blancs secs et équilibrés"
      },
      foodPairing: "Charcuteries, fromages, poissons, cuisine alsacienne"
    },
    "haut-rhin": {
      name: "Haut-Rhin",
      description: "Région méridionale produisant des vins blancs de grande qualité, avec une forte concentration de grands crus.",
      characteristics: {
        climate: "Climat continental sec et ensoleillé",
        soil: "Sols de granit, schiste et calcaire",
        viticulture: "Viticulture traditionnelle, grands crus"
      },
      grapeVarieties: {
        white: ["Riesling", "Gewürztraminer", "Pinot Gris", "Muscat"],
        red: ["Pinot Noir"]
      },
      wineStyles: {
        "riesling-haut-rhin": "Vins blancs secs et complexes",
        "gewurztraminer-haut-rhin": "Vins blancs aromatiques et puissants",
        "pinot-gris-haut-rhin": "Vins blancs secs et structurés"
      },
      foodPairing: "Charcuteries, fromages affinés, poissons, cuisine gastronomique"
    },
    "cremant-dalsace": {
      name: "Crémant d'Alsace",
      description: "Région produisant des vins effervescents de qualité, méthode traditionnelle, avec les cépages alsaciens.",
      characteristics: {
        climate: "Climat continental sec",
        soil: "Sols variés selon les sous-régions",
        viticulture: "Viticulture traditionnelle, méthode traditionnelle"
      },
      grapeVarieties: {
        white: ["Pinot Blanc", "Pinot Gris", "Riesling", "Chardonnay"],
        red: ["Pinot Noir"]
      },
      wineStyles: {
        "cremant-blanc": "Vins effervescents blancs secs",
        "cremant-rose": "Vins effervescents rosés",
        "cremant-brut": "Vins effervescents très secs"
      },
      foodPairing: "Apéritifs, fruits de mer, poissons, fromages frais"
    }
  }
}); 